import { t } from '@/lib/i18n';
import { createFileRoute, Link } from '@tanstack/react-router';
import { AuthLayout } from '@/components/auth-layout';
import { OneTimeTokenForm } from '@/features/auth/one-time-token/form';
import { useRedirectNavigation } from '@/features/auth/use-redirect-navigation';
import { useDocumentTitle } from '@/hooks/use-document-title';
import { sanitizeRedirect } from '@/lib/routes';

export const Route = createFileRoute('/_auth/one-time-token')({
  validateSearch: (search: Record<string, unknown>) => ({
    redirect: sanitizeRedirect(search.redirect),
  }),
  component: OneTimeTokenPage,
});

function OneTimeTokenPage() {
  useDocumentTitle(t('一次性令牌登录'));
  const { redirect: redirectTo } = Route.useSearch();
  const goToRedirect = useRedirectNavigation();
  return (
    <AuthLayout
      title={t('一次性令牌登录')}
      subtitle={t('在已登录设备的安全设置中生成令牌，再粘贴到这里。')}
    >
      <OneTimeTokenForm onAuthenticated={() => goToRedirect(redirectTo)} />
      <div className="auth-form__switch">
        <Link to="/login" search={{ redirect: redirectTo }}>
          {t('返回密码登录')}
        </Link>
      </div>
    </AuthLayout>
  );
}
